var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout",attrs:{"id":"app"}},[(_vm.userProfile)?_c('SideNav',{staticClass:"sidebar",on:{"active":_vm.isActive}}):_vm._e(),_c('main',{staticClass:"router-view",class:{ active: _vm.active, 'not-logged': !_vm.userProfile }},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }